import { render, staticRenderFns } from "./index.vue?vue&type=template&id=6185375c&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=6185375c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6185375c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/pre预发布-anjun-express-web-management/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6185375c')) {
      api.createRecord('6185375c', component.options)
    } else {
      api.reload('6185375c', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=6185375c&scoped=true", function () {
      api.rerender('6185375c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/bulkyExpress/oversizedDashboard/oversizeOrderDashboard/index.vue"
export default component.exports